import React from 'react';
import classnames from 'classnames';
import { MicroText } from '@sb1/ffe-core-react';
import { getBalanceAriaLabel } from '../translations';
export function OptionBody(_a) {
    var item = _a.item, dropdownAttributes = _a.dropdownAttributes, isHighlighted = _a.isHighlighted, locale = _a.locale;
    var titleAttribute = dropdownAttributes[0], restAttributes = dropdownAttributes.slice(1);
    var title = item[titleAttribute];
    var rest = restAttributes.map(function (attribute, index) { return (React.createElement(MicroText, { "aria-label": attribute === 'balance'
            ? getBalanceAriaLabel(locale, item[attribute])
            : undefined, className: "ffe-searchable-dropdown__detail-text", key: index }, item[attribute])); });
    return (React.createElement("div", { className: classnames('ffe-searchable-dropdown__list-item-body', {
            'ffe-searchable-dropdown__list-item-body--highlighted': isHighlighted,
        }) },
        title,
        !!rest.length && (React.createElement("div", { className: "ffe-searchable-dropdown__list-item-body-details" }, rest))));
}
